var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 0 1 9 0c0 7.2-9 12.6-9 12.6S1 12.7 1 5.5a4.5 4.5 0 0 1 9 0h0z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 2,
    fillOpacity: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgHeart as ReactComponent };
export default "data:image/svg+xml,export default 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZD0iTTEwIDUuNWE0LjUgNC41IDAgMCAxIDkgMGMwIDcuMi05IDEyLjYtOSAxMi42UzEgMTIuNyAxIDUuNWE0LjUgNC41IDAgMCAxIDkgMGgweiIgZmlsbD0iaW5oZXJpdCIgc3Ryb2tlPSJpbmhlcml0IiBzdHJva2Utd2lkdGg9IjIiIGZpbGwtb3BhY2l0eT0iaW5oZXJpdCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+'";